<template>
  <Container v-if="content.images" tagName="section" class="ProductImageGalleryContainer">
    <div class="ProductImageGallery">
      <SanityImage :asset="content.images[0].image.asset" />
    </div>
  </Container>
</template>

<script>

export default {
  props: {
    content: Object,
  },
}
</script>

<style scoped>
  .ProductImageGalleryContainer {
    background-color: var(--bg-color-dark-blue);
  }
  .ProductImageGallery {
    padding-top: var(--spacing-12);
    padding-bottom: var(--spacing-12);
  }
</style>
